import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-artista-page',
  templateUrl: './artista-page.component.html',
  styleUrls: ['./artista-page.component.css']
})
export class ArtistaPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
